export default __webpack_public_path__ + "static/media/girl.49e9e3d5.png";